'use strict';
(function($){
	/*
	 * Vetology.VetologyReports widget
	 *
	 * @description	This is the main Vetology VetologyReports widget
	 *
	 * @options		See description for each option
	 *
	 * @method		See description above each method
	 */
	$.widget(
		'Vetology.VetologyReports',
		{
			"options": {
			},
			/*
			 * Vetology.VetologyReports._init
			 *
			 * @description	Initializes the Vetology.VetologyReports
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				o._eventHandlers();
			},
			/*
			 * Vetology.Vetology._eventHandlers
			 *
			 * @description	
			 *
			 * @return NULL
			 *
			 */
			"_eventHandlers": function(){
				var o = this;
				$("body").on("click", ".getReport", function(){
					o._getReport();
				});
			},
			/*
			 * Vetology.Vetology._loadInterval
			 *
			 * @description	
			 *
			 * @return NULL
			 *
			 */
			"_getReport": function(init){
				var d = {
					from: $(".from_date").val(),
					to: $(".to_date").val(),
					group_id: $(".group_id").val(),
					clinic_id: $(".clinic_id").val(),
					report_type: $(".report_type").val()
				};
				$("body").Vetology("doRequest", "POST", d, "/admin/reports", function(data){
					$('.reportSection').empty();
					$('.reportSection').html(data);
				}, "html", true, "Please wait while I pull the report", "Please wait while I pull the report, this usually takes a bit...");
			}
		}
	);
})(jQuery);